import publicReq, { privateReq, imageUpload } from './axiosConfig';

export const addJobService = (data) =>
    privateReq.post("/job/add-job", data);
export const getJobsListService = (data) =>
    privateReq.get("/job/job-list" + data);

export const updateJobService = (data) => privateReq.post("/update-job", data);
export const deleteJobService = (data) => privateReq.delete("/delete-job/" + data.id);